module.exports = __webpack_public_path__ + "img/icon-chevron-right.c718691d.svg";